export function generateBreadcrumbFromUrl({ url, pk, label = '' }) {
  if (!url) {
    return [];
  }

  const items = [];
  items.push({ label, url });
  const parts = url.split('/').filter((part) => part);

  const toTitleCase = (str) => {
    return str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const createBreadcrumbData = (item) => {
    return {
      pk: String(pk),
      label: label !== '' ? label : toTitleCase(item),
      extra_context: {
        attributes: {
          category_id: 0
        },
        numchild: 0
      },
      generator_name: 'flatpage',
      level: 0,
      parent: null,
      parent_pk: null,
      path: '',
      sort_order: 0,
      url: label !== '' ? item?.url : `/${item}`
    };
  };

  if (label !== '') {
    return items.map(createBreadcrumbData);
  } else {
    return parts.map(createBreadcrumbData);
  }
}
